import '../base';

import 'focus-visible';

// Objects
import '../objects/light-box';

import '../settings/animation';

// Let CSS know JS is available
document.documentElement.classList.remove('js-unavailable');
document.documentElement.classList.add('js-available');
